import React from "react";

import OrderExportSetting from "app/orders/modules/generic/exportSetting/order";

import { withErrorBoundary, withFeature } from "lib/hoc";

import constant from "lib/constant/constant";

const OperatorOrderExportSetting = () => {
  return <OrderExportSetting />;
};
export default withFeature(withErrorBoundary(OperatorOrderExportSetting), {
  feature: constant.ORDER_EXPORT_SETTING,
});
